const ugHeroSection = $('#hero-section');

const scrollToHashBlock = () => {
  const hash = window.location.hash;

  if (!hash) return;

  const params = new URLSearchParams(hash.substring(1));
  const step = params.get('step');

  if (!step) return;

  const el = $(`[data-step="${step}"]`);
  lenis.resize()
  lenis.scrollTo(el.get(0), {
    duration: 0.633,
    force: true,
  });
}

const addUgHeroIn = () => {
  const animationConfig = {
    offsetPercent: '150',
    opacityStart: 0.9,
    blurStart: '5px',
    duration: 0.9,
    delay: 0,
    stagger: 0.15,
    isDurationCommon: false,
  }
  
  const heroDescription = ugHeroSection.find('.hero-section-descriptor');
  const heroTitle = ugHeroSection.find('.hero-section-title');
  const heroImage = ugHeroSection.find('.hero-image-preview-parent');
  const heroDescriptorCard = ugHeroSection.find('.descriptor-card');
  const heroBtn = ugHeroSection.find('.button-parent');
  const scrollHandler = ugHeroSection.find('.scroll-handle');
  const navParent = ugHeroSection.find('.hero-switcher-placer');

  const heroTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      $(window).trigger('heroReady');
      scrollToHashBlock();
    },
  });
  heroTL.addLabel('step1');

  if (isDesktop()) {
    heroTL.add(elementInAnimationYWOpacity(scrollHandler, '200%', 0, 1, 0.667, 0.667, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 'step1+=0.95');
    //heroTL.add(addElementInAnimation(scrollHandler, '200%', 0.667, 0).play(), 'step1+=0.95');
    heroTL.add(addDescriptorCardAnimation(heroDescriptorCard, '100%', 0.667, 0).play(), 'step1+=0.9');
  }
  heroTL.add(addTitleAnimation({element: heroTitle, animationConfig: animationConfig}).play(), 'step1+=0.5');
  heroTL.add(elementInAnimationYWOpacity(heroImage, '100%', 0, 1, 0.9, 0.9, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 'step1+=0.8');
  heroTL.add(elementInAnimationYWOpacity(heroDescription, '1000%', 0, 1, 0.9, 0.9, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 'step1+=0.5');
  //heroTL.add(addElementInAnimation(heroImage, '100%', 0.9, 0).play(), 'step1+=0.8');
  //heroTL.add(addElementInAnimation(heroDescription, '1000%', 0.9, 0).play(), 'step1+=0.5');
  heroTL.add(headerAnimation(true, 0.6, 0.01).play(), 'step1+=1.7');

  return heroTL;
};

$(window).on('load', () => {
  const [nav] = performance.getEntriesByType('navigation');
  const ugHeroTL = addUgHeroIn();
  pageIn(ugHeroTL, nav);
});
